<template>
  <div id="app">
    <router-view></router-view>
    <!-- <div id="wrapper">
      <div id="feedback" v-if="feedbackUrl">
        <button @click="openFeedback"><i class="fas fa-comment"></i> Feedback</button>
      </div>
    </div> -->

  </div>
</template>

<script>
document.addEventListener('touchstart', () => {}, true)

export default {
  name: 'app',
  methods: {
    openFeedback() {
      window.open(this.feedbackUrl)
    }
  },
  computed: {
    feedbackUrl() {
      return this.$store.state.university.feedback_url
    }
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// App.vue?1695adaf